import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button } from '@lt/components';

import Icon from '../../../../components/Icon';
import { NBSP } from '../../../../constants/common';

import {
  formatDateToDayWithMonth,
  convertClientDateToServerDate,
} from '../../../../utils/dateUtils';

// TODO: можно унифицировать блок
const SearcherEmptyRequest = ({ isMobile, date, onClick }) => {
  const parseDate = convertClientDateToServerDate(date);
  const dateText = formatDateToDayWithMonth(parseDate);

  return (
    <StyledContainer isMobile={isMobile}>
      <StyledIcon
        type="searcher-empty-request"
        width="129px"
        isMobile={isMobile}
      />
      <StyledHeader isMobile={isMobile}>
        {`Узнайте актуальные цены на${NBSP}туры с${NBSP}вылетом ${dateText}`}
      </StyledHeader>
      <StyledButton onClick={() => onClick(date)}>
        {`Показать туры на ${dateText}`}
      </StyledButton>
    </StyledContainer>
  );
};

SearcherEmptyRequest.propTypes = {
  isMobile: PropTypes.bool,
  date: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
SearcherEmptyRequest.defaultProps = {
  isMobile: false,
};

const StyledContainer = styled.div`
  margin: 0 auto;
  padding: ${(props) => (props.isMobile ? '5px 0 15px' : '50px 0 100px')};
  display: flex;
  width: ${({ isMobile }) => (isMobile ? '290px' : '420px')};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const StyledHeader = styled.div`
  margin-bottom: 8px;
  font-size: ${(props) => (props.isMobile ? '18px' : '22px')};
  font-weight: bold;
  color: ${(props) => props.theme.colors.blackBase};
`;

const StyledButton = styled(Button).attrs({ size: 'large' })`
  width: 220px;
  font-size: 14px;
`;

const StyledIcon = styled(Icon)`
  margin: 0 0 3px 12px;
`;

export default SearcherEmptyRequest;
